var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":require("../../assets/img/pre_active.jpg"),"alt":"","srcset":""}}),_c('div',{staticClass:"btn"},[_c('img',{attrs:{"src":require("../../assets/img/pre_btn.png"),"alt":""},on:{"click":_vm.toPre}})])]),_c('div',{staticClass:"content"})])
}
var staticRenderFns = []

export { render, staticRenderFns }